<template functional>
	<div class="form-error type--sans type--s">
		<transition name="fade-quick">
			<div v-if="props.error" class="form-error__message">{{ props.message }}</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: "FormError",
	props: {
		error: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			default: "Invalid input"
		}
	}
}
</script>

<style lang="scss" scoped></style>
